import React from 'react';
import { Container, Row, Col, Button, Card, Image } from 'react-bootstrap';
import { Helmet } from "react-helmet";
import { Link, useLocation } from 'react-router-dom';
import { settings } from '../config/settings';
import logo from '../assets/logo.webp';
import Gallery from '../components/Gallery';
import heroVideo from '../assets/video.mp4';

const Home = () => {
    return (
        <>
            <Helmet>
                <title>{settings.title} - CROSSFIT e HYROX</title>
                <meta name="description" content="TUTTI GLI ALLENAMENTI CHE TI CAMBIANO DAVVERO. Migliora forza, resistenza e mentalità con Gate51" />
            </Helmet>

            {/* Hero Section */}
            <section className="hero-section" style={{
                background: 'linear-gradient(135deg, #1a1a1a 0%, #2d2d2d 100%)',
                color: '#fff',
                padding: '60px 0',
                textAlign: 'center'
            }}>
                <Container>
                    <Image src={logo} width={200} className='mb-5' />
                    <h1 style={{ fontSize: '3.5rem', fontWeight: 'bold', marginBottom: '20px' }}>
                        CROSSFIT e HYROX
                    </h1>
                    <h2 style={{ fontSize: '2rem', marginBottom: '30px', fontWeight: '300' }}>
                        GLI ALLENAMENTI CHE TI CAMBIANO DAVVERO
                    </h2>
                    <p style={{ fontSize: '1.3rem', maxWidth: '800px', margin: '0 auto 40px', lineHeight: '1.6' }}>
                        MIGLIORA FORZA, RESISTENZA e MENTALITÀ<br />
                        PREPARATI A SFIDARE TE STESSO OGNI GIORNO CON LA GUIDA DI COACH ESPERTI<br />
                        e LA SPINTA DELLA NOSTRA COMMUNITY
                    </p>
                    <div style={{ display: 'flex', gap: '20px', justifyContent: 'center', flexWrap: 'wrap' }}>
                        <Button
                            size="lg" variant="light" style={{ padding: '15px 40px', fontSize: '1.1rem' }}
                            onClick={() => {
                                document.getElementById('crossfit-section').scrollIntoView({ behavior: 'smooth' });
                            }}
                        >
                            VOGLIO FARE<br />CROSSFIT / HYROX
                        </Button>
                        <Button
                            size="lg" variant="outline-light" style={{ padding: '15px 40px', fontSize: '1.1rem' }}
                            onClick={() => {
                                document.getElementById('hyrox-section').scrollIntoView({ behavior: 'smooth' });
                            }}
                        >
                            COSA SONO<br />CROSSFIT / HYROX
                        </Button>
                    </div>
                </Container>
            </section>

            {/* Video Section */}
            <section style={{ padding: '80px 0', backgroundColor: '#f8f9fa' }}>
                <Container>
                    <div style={{
                        width: '100%',
                        maxWidth: '900px',
                        margin: '0 auto',
                        borderRadius: '10px',
                        overflow: 'hidden'
                    }}>
                        <video
                            src={heroVideo}
                            autoPlay
                            muted
                            loop
                            playsInline
                            style={{ width: '100%', display: 'block' }}
                        />
                    </div>
                </Container>
            </section>

            {/* Two Paths Section */}
            <section id="crossfit-section" style={{ padding: '80px 0' }}>
                <Container>
                    <h2 className="text-warning" style={{ textAlign: 'center', fontSize: '2.5rem', marginBottom: '60px', fontWeight: 'bold' }}>
                        VOGLIO FARE CROSSFT / HYROX
                    </h2>
                    <Row className="g-4">
                        <Col md={6}>
                            <Card style={{ height: '100%', border: 'none', boxShadow: '0 4px 6px rgba(0,0,0,0.1)' }}>
                                <Card.Body style={{ padding: '40px', textAlign: 'center' }}>
                                    <h3 style={{ fontSize: '2rem', marginBottom: '30px', fontWeight: 'bold' }}>
                                        SONO UN<br />PRINCIPIANTE
                                    </h3>
                                    <Button
                                        variant="dark"
                                        size="lg"
                                        style={{ marginBottom: '20px', width: '100%', maxWidth: '300px' }}
                                        onClick={() => {
                                            document.getElementById('principianti-section').scrollIntoView({ behavior: 'smooth' });
                                        }}
                                    >
                                        Scopri di più
                                    </Button>
                                </Card.Body>
                            </Card>
                        </Col>
                        <Col md={6}>
                            <Card style={{ height: '100%', border: 'none', boxShadow: '0 4px 6px rgba(0,0,0,0.1)' }}>
                                <Card.Body style={{ padding: '40px', textAlign: 'center' }}>
                                    <h3 style={{ fontSize: '2rem', marginBottom: '30px', fontWeight: 'bold' }}>
                                        PRATICO GIÀ<br />CROSSFIT / HYROX
                                    </h3>
                                    <Button
                                        variant="dark"
                                        size="lg"
                                        style={{ marginBottom: '20px', width: '100%', maxWidth: '300px' }}
                                        onClick={() => {
                                            document.getElementById('esperti-section').scrollIntoView({ behavior: 'smooth' });
                                        }}
                                    >
                                        Scopri di più
                                    </Button>
                                </Card.Body>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </section>

            {/* 3 Passi Section - Per Principianti */}
            <section id="principianti-section" style={{ padding: '80px 0', backgroundColor: '#1a1a1a', color: '#fff' }}>
                <Container>
                    <h2 style={{ textAlign: 'center', fontSize: '2.5rem', marginBottom: '20px', fontWeight: 'bold' }}>
                        I TUOI 3 PASSI
                    </h2>
                    <p style={{ textAlign: 'center', fontSize: '1.2rem', marginBottom: '60px', color: '#ccc' }}>
                        Per iniziare il tuo percorso
                    </p>

                    <Row>
                        <Col md={4} className='mb-5'>
                            <div style={{ textAlign: 'center' }}>
                                <div style={{
                                    width: '80px',
                                    height: '80px',
                                    borderRadius: '50%',
                                    backgroundColor: '#fff',
                                    color: '#1a1a1a',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    fontSize: '2rem',
                                    fontWeight: 'bold',
                                    margin: '0 auto 30px'
                                }}>
                                    1
                                </div>
                                <h3 style={{ fontSize: '1.5rem', marginBottom: '20px', fontWeight: 'bold' }}>
                                    CHECK IN
                                </h3>
                                <h4 style={{ fontSize: '1.2rem', marginBottom: '15px', color: '#ffd700' }}>
                                    SETTIMANA DI PROVA GRATUITA
                                </h4>
                                <p style={{ fontSize: '1rem', lineHeight: '1.6', color: '#ccc' }}>
                                    ENTRA NEL MONDO CF/HY CON UNA SETTIMANA DI LEZIONI DEDICATE AI PRINCIPIANTI.
                                    ALLENAMENTI IN PICCOLI GRUPPI, SEGUITI PASSO PASSO DAI COACH PER IMPARARE LA
                                    TECNICA, CAPIRE COME ADATTARE I CARICHI E INIZIARE IN SICUREZZA.
                                </p>
                            </div>
                        </Col>
                        <Col md={4} className='mb-5'>
                            <div style={{ textAlign: 'center' }}>
                                <div style={{
                                    width: '80px',
                                    height: '80px',
                                    borderRadius: '50%',
                                    backgroundColor: '#fff',
                                    color: '#1a1a1a',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    fontSize: '2rem',
                                    fontWeight: 'bold',
                                    margin: '0 auto 30px'
                                }}>
                                    2
                                </div>
                                <h3 style={{ fontSize: '1.5rem', marginBottom: '20px', fontWeight: 'bold' }}>
                                    ON RAMP
                                </h3>
                                <h4 style={{ fontSize: '1.2rem', marginBottom: '15px', color: '#ffd700' }}>
                                    PREPARATI A ENTRARE IN CLASSE
                                </h4>
                                <p style={{ fontSize: '1rem', lineHeight: '1.6', color: '#ccc' }}>
                                    DOPO LA SETTIMANA DI PROVA, PRIMA DI ENTRARE IN CLASSE, 2 LEZIONI DI
                                    PERFEZIONAMENTO MIGLIORANO TECNICA, CONTROLLO E CONSAPEVOLEZZA. COSÌ POTRAI
                                    AFFRONTARE LE CLASSI IN SICUREZZA E DIVERTIRTI FIN DA SUBITO.
                                </p>
                            </div>
                        </Col>
                        <Col md={4} className='mb-5'>
                            <div style={{ textAlign: 'center' }}>
                                <div style={{
                                    width: '80px',
                                    height: '80px',
                                    borderRadius: '50%',
                                    backgroundColor: '#fff',
                                    color: '#1a1a1a',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    fontSize: '2rem',
                                    fontWeight: 'bold',
                                    margin: '0 auto 30px'
                                }}>
                                    3
                                </div>
                                <h3 style={{ fontSize: '1.5rem', marginBottom: '20px', fontWeight: 'bold' }}>
                                    ON BOARDING
                                </h3>
                                <h4 style={{ fontSize: '1.2rem', marginBottom: '15px', color: '#ffd700' }}>
                                    ENTRA NEL CUORE DELLA COMMUNITY
                                </h4>
                                <p style={{ fontSize: '1rem', lineHeight: '1.6', color: '#ccc' }}>
                                    È IL MOMENTO DI UNIRTI ALLE CLASSI E VIVERE L'ESPERIENZA COMPLETA. CON IL
                                    SUPPORTO COSTANTE DEI COACH E LA SPINTA DELLA COMMUNITY, OGNI ALLENAMENTO
                                    DIVENTA UN PASSO AVANTI VERSO I TUOI OBIETTIVI.
                                </p>
                            </div>
                        </Col>
                    </Row>

                    <div style={{ textAlign: 'center', marginTop: '60px' }}>
                        <Link to="/contact">
                            <Button
                                variant="light"
                                size="lg"
                                style={{ padding: '15px 50px', fontSize: '1.2rem', fontWeight: 'bold' }}
                            >
                                PARLA CON UN COACH SU WHATSAPP
                            </Button>
                        </Link>
                    </div>
                </Container>
            </section>

            {/* Per chi pratica già CF */}
            <section id="esperti-section" style={{ padding: '80px 0', backgroundColor: '#f8f9fa' }}>
                <Container>
                    <h2 style={{ textAlign: 'center', fontSize: '2.5rem', marginBottom: '30px', fontWeight: 'bold' }}>
                        PER TE CHE PRATICHI GIÀ CROSSFIT / HYROX
                    </h2>
                    <p style={{
                        textAlign: 'center',
                        fontSize: '1.3rem',
                        marginBottom: '50px',
                        maxWidth: '700px',
                        margin: '0 auto 50px'
                    }}>
                        HAI GIÀ LE BASI? PERFETTO. NON TI RESTA CHE PRENOTARE LA TUA PRIMA LEZIONE
                        ED ENTRARE SUBITO A FAR PARTE DEL GATE51
                    </p>
                    <div style={{ textAlign: 'center' }}>
                        <Link to="/contact">
                            <Button
                                variant="dark"
                                size="lg"
                                style={{ padding: '15px 50px', fontSize: '1.2rem', fontWeight: 'bold' }}
                            >
                                CHIEDI INFO E PRENOTA SU WHATSAPP
                            </Button>
                        </Link>
                    </div>
                </Container>
            </section>

            {/* CrossFit e Hyrox Description */}
            <section id="hyrox-section" style={{ padding: '80px 0' }}>
                <Container>
                    <Row className="align-items-top text-white">
                        <Col lg={6} className='mb-5'>
                            <h2 style={{ fontSize: '2.5rem', marginBottom: '30px', fontWeight: 'bold' }}>
                                CROSSFIT COS'È
                            </h2>
                            <p style={{ fontSize: '1.1rem', lineHeight: '1.8', marginBottom: '20px' }}>
                                MOVIMENTI FUNZIONALI AD ALTA INTENSITÀ CHE COMBINANO FORZA, RESISTENZA E TECNICA.
                            </p>
                            <p style={{ fontSize: '1.1rem', lineHeight: '1.8' }}>
                                DIVERTENTE, COMPLETO E ADATTO A TUTTI, DAL PRINCIPIANTE ALL'ATLETA.
                            </p>
                        </Col>
                        <Col lg={6} className='mb-5'>
                            <h2 style={{ fontSize: '2.5rem', marginBottom: '30px', fontWeight: 'bold' }}>
                                HYROX COS'È
                            </h2>
                            <p style={{ fontSize: '1.1rem', lineHeight: '1.8', marginBottom: '20px' }}>
                                LA SFIDA CHE UNISCE CORSA E FUNCTIONAL TRAINING.
                            </p>
                            <p style={{ fontSize: '1.1rem', lineHeight: '1.8' }}>
                                UN FORMAT UNICO PER SPINGERTI A SUPERARE I TUOI LIMITI E DIVERTIRTI
                                ALLENAMENTO DOPO ALLENAMENTO.
                            </p>
                        </Col>
                    </Row>
                </Container>
            </section>

            {/* Gallery */}
            <Gallery />

            {/* Inside Gate51 */}
            <section style={{ padding: '80px 0', backgroundColor: '#1a1a1a', color: '#fff' }}>
                <Container>
                    <h2 style={{ textAlign: 'center', fontSize: '2.5rem', marginBottom: '30px', fontWeight: 'bold' }}>
                        INSIDE GATE51
                    </h2>
                    <p style={{ fontSize: '1.2rem', lineHeight: '1.8', marginBottom: '30px' }}>
                        NATO NEL 2019, GATE51 È IL RISULTATO DEL SOGNO DI CREARE UNA STRUTTURA CAPACE
                        DI TRASMETTERE PASSIONE FIN DAL PRIMO ALLENAMENTO.
                    </p>
                    <p style={{ fontSize: '1.2rem', lineHeight: '1.8', marginBottom: '30px' }}>
                        OGGI GATE51 È UN CENTRO DI OLTRE 850m² DEDICATO A CF E HY, ATTREZZATO CON
                        PARTNER TECNICI COME HATLEX E KINGSBOX PER GARANTIRE ALLENAMENTI AL TOP IN
                        OGNI DISCIPLINA.
                    </p>

                    <h3 style={{ fontSize: '2rem', marginTop: '50px', marginBottom: '30px', fontWeight: 'bold' }}>
                        ACCANTO ALL'AREA TRAINING TROVERAI:
                    </h3>

                    <Row className="g-4">
                        <Col md={6}>
                            <Card style={{ backgroundColor: '#2d2d2d', border: 'none', color: '#fff', height: '100%' }}>
                                <Card.Body style={{ padding: '30px' }}>
                                    <h4 style={{ fontSize: '1.5rem', marginBottom: '20px', color: '#ffd700' }}>
                                        350 m² DI GATE51 BOULDER
                                    </h4>
                                    <p style={{ fontSize: '1.1rem', lineHeight: '1.6' }}>
                                        IL NOSTRO CENTRO PER L'ARRAMPICATA INDOOR
                                    </p>
                                </Card.Body>
                            </Card>
                        </Col>
                        <Col md={6}>
                            <Card style={{ backgroundColor: '#2d2d2d', border: 'none', color: '#fff', height: '100%' }}>
                                <Card.Body style={{ padding: '30px' }}>
                                    <h4 style={{ fontSize: '1.5rem', marginBottom: '20px', color: '#ffd700' }}>
                                        150 m² DI HEALTH51
                                    </h4>
                                    <p style={{ fontSize: '1.1rem', lineHeight: '1.6' }}>
                                        UN CENTRO DEDICATO A BENESSERE E PERFORMANCE, CON STUDI PROFESSIONALI
                                        CON TEAM COMPOSTI DA FISIOTERAPISTI, PSICOLOGi E NUTRIZIONISTi
                                    </p>
                                </Card.Body>
                            </Card>
                        </Col>
                    </Row>

                    <p style={{
                        fontSize: '1.3rem',
                        textAlign: 'center',
                        marginTop: '50px',
                        fontWeight: 'bold',
                        color: '#ffd700'
                    }}>
                        UN UNICO SPAZIO, TRE ANIME, UN'UNICA MISSIONE:<br />
                        FARTI VIVERE LO SPORT A 360°, CON LA QUALITÀ E CURA CHE MERITI
                    </p>

                    <div style={{ textAlign: 'center', marginTop: '40px', display: 'flex', gap: '20px', justifyContent: 'center', flexWrap: 'wrap' }}>
                        <Link to="/orari">
                            <Button variant="light" size="lg" style={{ padding: '15px 40px' }}>
                                ORARI
                            </Button>
                        </Link>
                        <Link to="/prezzi">
                            <Button variant="outline-light" size="lg" style={{ padding: '15px 40px' }}>
                                PREZZI
                            </Button>
                        </Link>
                    </div>
                </Container>
            </section>

            {/* Programmi Speciali */}
            <section style={{ padding: '80px 0', backgroundColor: '#f8f9fa' }}>
                <Container>
                    <h2 style={{ textAlign: 'center', fontSize: '2.5rem', marginBottom: '60px', fontWeight: 'bold' }}>
                        PROGRAMMI SPECIALI
                    </h2>

                    <Row className="g-4">
                        <Col md={4}>
                            <Card style={{ height: '100%', border: 'none', boxShadow: '0 4px 6px rgba(0,0,0,0.1)' }}>
                                <Card.Body style={{ padding: '40px', textAlign: 'center' }}>
                                    <h3 style={{ fontSize: '1.8rem', marginBottom: '20px', fontWeight: 'bold' }}>
                                        CROSSFIT SENIOR
                                    </h3>
                                    <p style={{ fontSize: '1.1rem', lineHeight: '1.6' }}>
                                        IL CF PENSATO PER CHI VUOLE RESTARE ATTIVO A OGNI ETÀ. ESERCIZI ADATTATI,
                                        COACHING ATTENTO E UN AMBIENTE ACCOGLIENTE.
                                    </p>
                                </Card.Body>
                            </Card>
                        </Col>
                        <Col md={4}>
                            <Card style={{ height: '100%', border: 'none', boxShadow: '0 4px 6px rgba(0,0,0,0.1)' }}>
                                <Card.Body style={{ padding: '40px', textAlign: 'center' }}>
                                    <h3 style={{ fontSize: '1.8rem', marginBottom: '20px', fontWeight: 'bold' }}>
                                        KIDS
                                    </h3>
                                    <p style={{ fontSize: '1.1rem', lineHeight: '1.6' }}>
                                        GIOCHI, MOVIMENTO E SPORT IN UN MIX PERFETTO: IL CF CHE AIUTA I PIÙ
                                        PICCOLI A CRESCERE FORTI, SANI E SORRIDENTI.
                                    </p>
                                </Card.Body>
                            </Card>
                        </Col>
                        <Col md={4}>
                            <Card style={{ height: '100%', border: 'none', boxShadow: '0 4px 6px rgba(0,0,0,0.1)' }}>
                                <Card.Body style={{ padding: '40px', textAlign: 'center' }}>
                                    <h3 style={{ fontSize: '1.8rem', marginBottom: '20px', fontWeight: 'bold' }}>
                                        PERSONAL
                                    </h3>
                                    <p style={{ fontSize: '1.1rem', lineHeight: '1.6' }}>
                                        CLASSI GUARDATE E SEGUITE CON ATTENZIONE PARTICOLARE PER CHI NECESSITA
                                        DI UN APPROCCIO PERSONALIZZATO.
                                    </p>
                                </Card.Body>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </section>

            {/* Final CTA WhatsApp */}
            <section style={{ padding: '80px 0', backgroundColor: '#25D366', color: '#fff', textAlign: 'center' }}>
                <Container>
                    <h2 style={{ fontSize: '2.5rem', marginBottom: '30px', fontWeight: 'bold' }}>
                        HAI QUALCHE CURIOSITÀ?
                    </h2>
                    <p style={{ fontSize: '1.3rem', marginBottom: '40px', maxWidth: '600px', margin: '0 auto 40px' }}>
                        Contattaci direttamente su WhatsApp per informazioni, prenotazioni e supporto immediato
                    </p>
                    <Link to="/contact">
                        <Button
                            variant="light"
                            size="lg"
                            style={{
                                padding: '15px 50px',
                                fontSize: '1.2rem',
                                fontWeight: 'bold',
                                color: '#25D366'
                            }}
                        >
                            CHATTA CON NOI SU WHATSAPP
                        </Button>
                    </Link>
                </Container>
            </section>
        </>
    );
};

export default Home;
